export const PRICES: TTDict<string, TTDict<string, number>> = {
  Wirtschaftskanzlei: {
    Einmalzahlung: 4950,
  },
  Privatkanzlei: {
    Einmalzahlung: 3950,
    "monatliche Zahlung": 349,
  },
};

export const ADDONS = ["Trophäe (990,00 €)", "Urkunde (690,00 €)"];

export const NO_INTEREST_REASONS = [
  { label: "Gesamtpreis zu hoch", value: "Gesamtpreis zu hoch" },
  { label: "Kein Interesse an Siegel", value: "Kein Interesse an Siegel" },
  { label: "Bewertung nicht nachvollziehbar", value: "Bewertung nicht nachvollziehbar" },
  { label: "Mit Erhebungsart nicht einverstanden", value: "Mit Erhebungsart nicht einverstanden" },
  { label: "Opt out - Kein Kontakt mehr erwünscht", value: "Opt out - Kein Kontakt mehr erwünscht" },
  { label: "Möchte nicht veröffentlicht werden", value: "Möchte nicht veröffentlicht werden" },
];
